import { createTheme } from "@mui/material/styles";

const toggleTheme = createTheme({
  components: {
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: {
          background: "#f4f6f8",
          borderRadius: "6px",
          padding: "2px",
          height: "36px",
        },
      },
    },

    MuiToggleButton: {
      styleOverrides: {
        root: {
          borderRadius: "4px",
          minHeight: "32px",
          padding: "0 32px", // px: 4
          fontSize: "13px",
          fontWeight: 600,
          textTransform: "none",
          color: "#4CAF50",
        //   border: "none",

          "&.Mui-selected": {
            backgroundColor: "#4CAF50",
            color: "#fff",
          },

          "&.Mui-selected:hover": {
            backgroundColor: "#43a047",
          },
        },
      },
    },
  },
});

export default toggleTheme;
